
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/furniture-partners",
      function () {
        return require("private-next-pages/furniture-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/furniture-partners"])
      });
    }
  